module.exports = __webpack_public_path__ + "jbClose.d1f98bef.png";